/*
 * @Description:
 * @Author: zhanglu
 * @Date: 2020-11-14 15:26:15
 * @LastEditors: zhanglu
 * @LastEditTime: 2020-11-25 11:10:49
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const { host, E6_MS_TMS_FINANCIAL_WEB } = e6ModuleSettleAccountsCenterApi;
//********************* 单条调整记录 ****************** */
// 记录list
export function getFeeChangeRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getFeeChangeRecord`,
    method: "post",
    data
  });
}
// 保存单条记录
export function saveOneRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/saveOneRecord`,
    method: "post",
    data
  });
}
